var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1922,
    height: 1080,
    viewBox: "0 0 1922 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1920,
    height: 1079.5,
    fill: "#E0F5C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M882.895 626.111C1307.28 546.964 1652.58 620.536 1921 668.238V961.883L1.00024 991V540C115.686 592.658 444.419 707.886 882.895 626.111Z",
    fill: "#E0F5C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.72 677.384C1524.12 755.829 1680.02 725.464 1921 677.384V1019H1.00024V604C169.197 815.929 796.738 611.883 1127.72 677.384Z",
    fill: "#C2D9A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.77 740.748C1200.66 773.893 1669.14 847.978 1921.33 762.245L1921.39 990.292L0.740203 990.787L0.675792 741.021C90.8247 752.46 237.831 791.034 478.019 790.972C570.628 790.948 909.419 705.378 1059.77 740.748Z",
    fill: "#97BF6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.57 824.961C1383.17 944.948 1662.03 873.203 1921 837.949V1021.64L1 1047V888.665C222.147 978.347 795.867 724.455 1063.57 824.961Z",
    fill: "#578C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M744.111 1000.52C1019.05 926.874 1699.37 847.721 1921 1010.28V1080H1V934.157C118.128 952.038 514.182 1062.12 744.111 1000.52Z",
    fill: "#215A2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGreen);
export default __webpack_public_path__ + "static/media/bgGreen.d922f521036e53d039ebf91c04274ff5.svg";
export { ForwardRef as ReactComponent };